module.exports = __webpack_public_path__ + "static/media/gp7.cf786b90.webp";